import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ExternalUrlConstants as urls } from '../../Config/UIConstants';
import { FullContainer } from '../../SharedComponents/FullContainer';
import { Routes } from '../../_controllers/RouteController';
import { ModalXIconInverse } from '../../images/images';
import { colors } from '../../styles/colors';

export class PrivacyPolicyPage extends React.Component<RouteComponentProps<any>> {

    public componentDidMount() {
        window.location.href = urls.PRIVACY_POLICY_URL;
    }

    public render() {
        return (
            <FullContainer style={styles.backgroundColor}>
                <div style={styles.textContainer}>
                    <p>Redirecting to <a href={urls.PRIVACY_POLICY_URL}>{urls.PRIVACY_POLICY_URL}</a></p>
                </div>
            </FullContainer>
        );
    }
}

const styles = {
    bodyText: {
        width: 600,
        marginBottom: 15
    },
    headerText: {
        paddingTop: 140,
        color: 'black',
        fontSize: 24,
        marginBottom: 40,
        textAlign: 'center'
    } as React.CSSProperties,
    textContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        paddingLeft: `calc(50vw - 250px)`,
        paddingRight: `calc(50vw - 250px)`,
        backgroundColor: '#F5F5F5',
        paddingTop: 100,
    } as React.CSSProperties,
    exitButton: {
        height: 50,
        width: 50,
        borderRadius: 25,
        top: 30,
        right: 60,
        position: 'fixed',
        backgroundColor: colors.DARK_GREY
    } as React.CSSProperties,
    backgroundColor: {
        backgroundColor: '#F5F5F5'
    }
};



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/PrivacyPolicyPage.tsx